import React from 'react';
import classNames from 'classnames';
import { Slider as AntdSlider } from 'antd';
import { SliderMarks as RangeMarks, HandleGeneratorFn, SliderBaseProps as RangeBaseProps, SliderRangeProps as RangeRangeProps, Visibles } from 'antd/es/slider';
import { ConfigContext } from '../config-provider';
import AntdConfigProvider from 'antd/es/config-provider';
const Range = React.forwardRef((props, ref) => {
    const { className, color, size = 'middle', shape = 'circle', ...otherProps } = props;
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('slider', props.prefixCls);
    const newClassName = classNames({
        [`${classPrefix}-sm`]: size === 'small',
        [`${classPrefix}-md`]: size === 'middle',
        [`${classPrefix}-lg`]: size === 'large',
        [`${classPrefix}-square`]: shape === 'square'
    }, className);
    return (React.createElement(AntdConfigProvider, { prefixCls: getPrefixCls('', props.prefixCls), ...restContext },
        React.createElement(AntdSlider, { ref: ref, prefixCls: classPrefix, className: newClassName, ...otherProps })));
});
export default Range;
